export default __webpack_public_path__ + "static/media/tavi_main_mobile_small.bd700b75.jpg";